<template>
  <div class="tag-layer" :class="{'edit-scene': selectedScene}" @click.exact="onClickLayer" @mousedown.alt.exact="isGridVisible = true" @mouseup="isGridVisible = false">
    <cling-grid :isVisible="isGridVisible" />
    <template v-if="selectedScene">
     
      <canvas class="tag_layer__canvas" :width="w +'px'" :height="h +'px'" />
      <!--
      <h3 class="tag-layer__title">{{ selectedScene.name }} {{ time }} {{ video.dimensions }} </h3>
      -->
      <!-- waypoints for now, TODO: nest them within an scene component to edit whole path -->
      <tag-waypoint v-for="(wp, index) in selectedScene.waypoints" :key="wp.time + wp.id" :bb="boundingBox" :scene="selectedScene" :wp="wp" :wpIndex="index" @click.stop="onSelectWaypoint(wp)" />
      <tag-waypoint v-if="selection.waypoint" class="tag-layer__current-waypoint is-selected" :bb="boundingBox" :wp="selection.waypoint" :showBounds="true" @editing="isEditing=true" />
    </template>
    <!-- no scene selected, replay of scenes, fetch currentWaypoint from play time and interpolate -->
    <tag-waypoint v-if="!selectedWaypoint && currentWaypoint" class="tag-layer__current-waypoint is-playing" v-on:click.stop="onSelectPlayingWaypoint" :wp="currentWaypoint" :showBounds="false" />
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex'
  /* TagLayer is the interaction layer to edit tags and waypoints */
  import TagWaypoint from './tagWaypoint'
  import guid from '../../utils/guid'
  import helpers from '../../store/helpers'
  import clingGrid from '../core/clingGrid'

  export default {
    name: 'tag-layer',

    components: {
      'tag-waypoint': TagWaypoint,
      'cling-grid': clingGrid
    },

    directives: {
      ready (e, binding) {
        if (typeof binding.value === 'function') {
          binding.value(e)
        }
      }
    },

    props: {
      time: {
        type: Number
      }
    },

    data: function () {
      return {
        w: 0,
        h: 0,
        quantizedTime: this.time,
        waypointSelected: false,
        isEditing: false,
        isGridVisible: false
      }
    },

    computed: {
      ...mapState(['video', 'player', 'selection']),

      selectedScene: function () {
        return this.selection.scene
      },

      selectedWaypoint: function () {
        return this.selection.waypoint
      },
      
      currentWaypoint: function () {
        let before, after
        let scene = this.selectedScene ? this.selectedScene : this.$store.getters.activeScene
        let ahead = this.player.paused() ? 0 : this.updateInterval / 1000 // due to transitions delay we need to look ahead video is playing
        let fTime = this.quantizedTime + ahead
        if (!scene) {
          return null
        }
        // find the waypoints before and after the current timestamp
        scene.waypoints.forEach(waypoint => {
          if (waypoint.time <= fTime && (!before || waypoint.time > before.time)) {
            before = waypoint
          }
          if (waypoint.time >= fTime && (!after || waypoint.time < after.time)) {
            after = waypoint
          }
        })
        // if before and after are equal we're exactly on this timestamp
        if (before === after) {
          return before
        }
        // otherwise interpolate an intermediate position for the current time
        if (before && after) {
          const currentTimeFraction = (fTime - before.time) / (after.time - before.time)
          return {
            x: before.x + (after.x - before.x) * currentTimeFraction,
            y: before.y + (after.y - before.y) * currentTimeFraction,
            w: before.w + (after.w - before.w) * currentTimeFraction,
            h: before.h + (after.h - before.h) * currentTimeFraction
          }
        }
        return null
      },

      boundingBox: function () {
        return {
          width: this.w,
          height: this.h
        }
      }
    },

    mounted() {
      // TODO: perf, this is expensive, lets see if we have a fixed size in the end
      // RESIZE: handle resize if needed
      // computed style
      if (this.selectedScene) {
        let cs = getComputedStyle(this.$el)
        this.w = parseInt(cs.width.replace('px'))
        this.h = parseInt(cs.height.replace('px'))
      }
      // first impl to get replay of waypoint decoupled from fuzzy videojs timeUpdate
      let video = this.$parent.$el.querySelector('video')
      this.updateInterval = 100
      setInterval(e => {
        this.quantizedTime = video.currentTime
      }, this.updateInterval)
      // FIX:: Copy Inital Waypoint
      this.$watch('selection', this.drawPath, {
        deep: true
      })
    },

    methods: {
      ...mapMutations(['setPlayer', 'selectTag', 'selectScene', 'selectWaypoint', 'setInfoKey', 'setPlayerTime']),
      ...mapActions(['createTag', 'createScene']),

      drawPath: function (oldScene, newScene) {
        const canvas = this.$el.querySelector('canvas')

        if (!canvas || !this.selectedScene) {
          return false
        }
          let cs = getComputedStyle(this.$el)
        this.w = parseInt(cs.width.replace('px'))
        this.h = parseInt(cs.height.replace('px'))
        // console.log('draw path', canvas, oldScene, newScene)
        const c = canvas.getContext('2d')
        c.clearRect(0, 0, canvas.width, canvas.height)
        c.beginPath()
        this.selectedScene.waypoints.forEach(({x, y}, idx) => {
          const coordinates = [canvas.width * x, canvas.height * y]
          if (idx > 0) {
            c.lineTo(...coordinates)
          } else {
            c.moveTo(...coordinates)
          }
        })
        c.strokeStyle = '#f00'
        c.lineWidth = 1
        c.setLineDash([5, 5])
        c.stroke()
      },

      onSelectPlayingWaypoint: function (ev) {
        console.log('onSelectPlayingWaypoint', ev)
        const time = this.player.currentTime()
        const wpInRange = helpers.findWaypointWithinTimeInterval(time, 3 / 24)
        if (wpInRange) {
          console.log('got wpInRange', wpInRange)
          this.selectWaypoint(wpInRange)
        } else {
          const wp1 = this.createWaypoint(ev)
          this.selectedScene.waypoints.push(wp1)
          this.selectWaypoint(wp1)
        }
      },

      onSelectWaypoint: function (wp) {
        console.log('onSelectWaypoint', wp)
        this.selectWaypoint(wp)
        this.waypointSelected = true
        // this.setInfoKey('editor.blank.edit.waypoint')
      },
      onClickLayer: function (e) {
        console.log('onClickLayer', e.target, this.selection)
        if (this.isEditing) {
          this.isEditing = false;
          return false;
        }

        if (!this.selection.tag) {
          return false
        }

        // abort on all tags that have one waypoint only
        if (this.selection.tag) {
          let template = this.selection.tag.template
          if(['quiz', 'singleChoice', 'logic'].indexOf(template) >= 0) {
            this.isEditing = false
            return false
          } 
        }

        if (e.target) {
          if (this.player) {
            this.player.pause()
          }

           // no new waypoint, if one is selected
          const time = this.player.currentTime()
          const waypoints = (this.selection.scene && this.selection.scene.waypoints) ? this.selection.scene.waypoints : null
          const wpAtCurrentTime = waypoints ? waypoints.find(wp => wp.time === time) : null

          console.log('onClickLayer', this.selection, time, wpAtCurrentTime)

          if (this.waypointSelected) {
            console.log('no new waypoint if one is already selected, or one is withing time constraint')
            this.waypointSelected = false
            return false
          }

          if (wpAtCurrentTime) {
              console.log('no new waypoint if one is withing time constraint, select this waypoint')
              const index = waypoints.indexOf(wpAtCurrentTime)
              const newTime = this.player.currentTime() + 1
              if (index === waypoints.length - 1) {
                this.setPlayerTime(newTime)
              } else {
                this.selectWaypoint(wpAtCurrentTime)
                return false
              }
          }

          let ww = 80
          let wh = 80

          if (this.selection.waypoint) {
            ww = this.selection.waypoint.w
            wh = this.selection.waypoint.h
          } else if (this.selectedScene && this.selectedScene.waypoints && this.selectedScene.waypoints.length > 0) {
            const lastWayPoint = this.selectedScene.waypoints[this.selectedScene.waypoints.length - 1]
            ww = lastWayPoint.w
            wh = lastWayPoint.h
          }

          const wp1 = this.createWaypoint(e, ww, wh)
          if (this.selectedScene) {
            this.selectedScene.waypoints.push(wp1)
          } else {
            const waypoints = []
            const videoScene = this.video.scenes.find(s => s.start <= time && s.end >= time)
            if (videoScene) {
              waypoints.push(wp1) // { time: videoScene.end, x: wp1.x, y: wp1.y, id: guid() })
            } else {
              waypoints.push(wp1) // {time: wp1.time + 5, x: wp1.x, y: wp1.y + 0.1, w: wp1.w, h: wp1.h, id: guid()})
            }
            this.createScene(waypoints).then(newScene => this.selectScene(newScene)).catch(e => console.error('failed to create new scene', e))
          }
          this.selectWaypoint(wp1)
        }
      },

      createWaypoint: function (e, ww = 80, wh = 80) {
        const time = this.player.currentTime()
        const playerBB = this.$el.getBoundingClientRect()
        const x = (e.clientX - playerBB.left) / playerBB.width
        const y = (e.clientY - playerBB.top) / playerBB.height
        const w = ww
        const h = wh
        const pw = w / playerBB.width
        const ph = h / playerBB.height
        const waypoint = { time, x, y, w, h, pw, ph, id: guid() }
        return waypoint
      }
    }
  }

</script>
